(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["nehan-compose-web"] = factory();
	else
		root["nehan-compose-web"] = factory();
})(globalThis, () => {
return 